<template>
    <div>
        <div v-if="landesverband">
            <div v-if="!verein || (verein && $vuetify.breakpoint.smAndUp)"
                 :class="[{'navDrawer': $vuetify.breakpoint.smAndUp},
                          {'navDrawerMob': $vuetify.breakpoint.xsOnly}]">
                <selection-list :list="vereine" :title="storeVerband.id + ' - '+ storeVerband.name"
                                @selected="selectVerein">
                    <div v-show="false" class="pt-3 pb-1">
                        <v-select v-model="sportJahr" :items="sportJahrList" filled
                                label="Sportjahr" hide-details></v-select>
                    </div>
                    <div v-if="user && user.permissions.pass" class="pt-2 ml-1 d-inline-block">
                        <tool-tip text="Neuen Verein anlegen">
                            <v-btn icon @click="openVereinNew()">
                                <v-icon>mdi-plus</v-icon>
                            </v-btn>
                        </tool-tip>
                    </div>
                    <div v-if="user" class="ml-1 pt-2 d-inline-block">
                        <tool-tip text="Spieler dieses LV herunterladen">
                            <v-btn icon @click="openDownload()" @click.stop @click.prevent>
                                <v-icon>mdi-account-arrow-down</v-icon>
                            </v-btn>
                        </tool-tip>
                        <spieler-export-dialog param="downloadLvSpieler" :lv-id="id" level="lv"/>
                    </div>
                </selection-list>
            </div>
            <div :class="[{'content': $vuetify.breakpoint.smAndUp}, 'pa-4']">
                <div v-if="verein">
                    <spieler-tabelle  :verein="verein" :lv="landesverband"
                                      :items="vereinsspieler" :itemsExpired="vereinsspielerExpired" :sport-jahr="sportJahr"
                                      columnListName="landesverband" @searchStatusChanged="reselectVerein"
                                      @vereinsAction="vereinsAction">
                    </spieler-tabelle>
                    <kugel-home v-if="user && user.permissions.pass" :owner="vereinKugel" owner-type="verein" class="elevation-2"/>
                </div>
                <div v-else class="grey--text pa-5">
                    Bitte einen Verein wählen!
                    <img width="300" src="../../assets/oeskb.png" class="logo">
                    <!--<div v-if="user.uid===$store.state.config.batchUpdate.user">
                        <v-btn  @click="updateBatch()">BATCH UPDATE</v-btn>
                        <v-text-field v-model="updateBatchValue" label="Wert eingeben"></v-text-field>-->
                    <!-- SONDERABFRAGE -->
                        <!--<v-btn @click="inaktiveLesen()">INAKTIVE LESEN</v-btn>
                        <p v-for="(item, i) in inaktive" :key="i">
                            {{item.id}}  ----  {{item.nachname}} {{item.vorname}}
                        </p>
                    </div>-->
                </div>
                <snackbar :msg="deleteSnack">
                </snackbar>
            </div>
            <verein-edit :currentData="currentVerein" :landesverband="landesverband"
                         @changeVerein="changeVerein">
            </verein-edit>
            <verein-edit-datenblatt :selectedVereinId="currentVerein"/>
        </div>
        <div v-else>
            loading!!!
        </div>
        <v-btn v-if="verein && $vuetify.breakpoint.xsOnly" fab dark bottom right
               color="primary" style="position: fixed; right: 15px; bottom: 15px; z-index: 15" @click="verein=null">
            <v-icon >mdi-arrow-left</v-icon>
        </v-btn>
        <confirm-dialog :open="confirmDelete.open" :header="confirmDelete.header" :question="confirmDelete.question"
                        @reply="processConfirm" query-parameter="confirmVereinDelete">
        </confirm-dialog>
    </div>
</template>

<script>
    import SelectionList from "../../components/selectionList";
    import {Landesverband} from "../../services/data/landesverband";
    import SpielerTabelle from "../spielerTabelle/spielerTabelle";
    import ToolTip from "../../components/elements/toolTip";
    import VereinEdit from "./vereinEdit";
    import Snackbar from "../../components/elements/snackbar";
    import {firestore} from "../../services/db";
    import ConfirmDialog from "../../components/navigation/confirmDialog";
    import TimeStamp from "../../services/timeStamp";
    import {db} from "../../services/db";
    import KugelHome from "@/views/kugeln/kugelHome";
    import SpielerExportDialog from "@/views/spielerExport/spielerExportDialog";
    import RouterServices from "@/utilities/services/router/routerServices";
    import VereinEditDatenblatt from "@/views/landesverband/vereinEditDatenblatt";
    import FirebaseRead from "@/services/database/firebaseRead";

    export default {
        components: {
            VereinEditDatenblatt,
            SpielerExportDialog,
            KugelHome,
            ConfirmDialog,
            Snackbar,
            VereinEdit, ToolTip, SpielerTabelle, SelectionList},
        name: "landesverband",
        computed: {
            user(){ return this.$store.state.user; },
            id(){ return this.$route.query.id },
            landesverbandRaw(){ return this.$store.state.realtime.landesverbaende[this.id]; },
            vereine(){ return this.landesverbandRaw ?
                            this.landesverband.getArrayFromMap(
                            this.landesverband.vereine
                        ).sort((a, b) => a.id > b.id ? 1 : -1) : []},
            vereinsspieler(){ return this.$store.state.realtime.vereinsspieler; },
            vereinsspielerExpired(){ return this.$store.state.realtime.vereinsspielerExpired; },
            sportJahrList(){ return this.$store.state.local.sportJahr.adminList },
            storeVerband() { return this.$store.state.local.landesverbaende.find(lv => lv.id === this.id) },
            vereinKugel(){
                const vereinKugel = JSON.parse(JSON.stringify(this.verein))
                vereinKugel.id = this.id + this.verein.id
                return vereinKugel
            }
        },
        data: () => ({
            inaktive: [],
            sportJahr: null,
            items: [
                { title: 'Dashboard', icon: 'mdi-view-dashboard' },
                { title: 'Photos', icon: 'mdi-image' },
                { title: 'About', icon: 'mdi-help-box' },
            ],
            right: null,
            verein: null,
            currentVerein: null,
            landesverband: null,
            deleteSnack: {
                show: false,
                color: 'error',
                timeout: 4000,
                text: '',
                dynamicText: null,
                actionButtonI18n: '',
            },
            confirmDelete: {
                open: false,
                question: '',
                item: null,
            },
            updateBatchValue: '',
        }),
        created(){
            this.sportJahr = JSON.parse(JSON.stringify( this.$store.state.local.sportJahr.current.value ));
            this.loadLandesVerband();
            if ( this.landesverbandRaw ) { this.setLandesverband(); }
        },
        methods: {
            /*inaktiveLesen(){
                db.collection("spieler").where("status", "==", "inaktiv")
                    .get()
                    .then((querySnapshot) => {
                        querySnapshot.forEach((doc) => {
                            // doc.data() is never undefined for query doc snapshots
                            //console.log(doc.id, " => ", doc.data());
                            let item = doc.data();
                            Object.keys(item.search.membershipYears).forEach( (year) => {
                                if ( year.indexOf('_2021_2022') !== -1 ) {
                                    item.id = doc.id;
                                    this.inaktive.push(item);
                                }
                            });
                        });
                        console.log ("Gesamt: ", this.inaktive.length);
                    })
                    .catch((error) => {
                        console.log("Error getting documents: ", error);
                    });
            },*/
            /*runConvert(){
                const x = this.vereine.length;
                let i = 0;
                let y = setInterval(()=>{
                    console.log (this.id + this.vereine[i].id);
                    this.updateBatch(this.id + this.vereine[i].id);
                    i++;
                    if ( i === x ) { clearInterval(y); console.log ("Intervall cleared");}
                }, 20000);
            },*/
            openDownload(){
                RouterServices.pushRouteQueryParameter(this.$router, this.$route, 'downloadLvSpieler', 'true' )
            },
            /*
            updateBatch(){
                if ( !this.updateBatchValue ) { console.error ("Bitte Wert eingeben!!!" ); return; }
                db.collection("batchUpdate").doc(this.$store.state.config.batchUpdate.documentId).update({
                    lastSportTag: this.updateBatchValue
                })
                    .then(() => {
                        console.log("Document successfully updated!");
                    })
                    .catch((error) => {
                        // The document probably doesn't exist.
                        console.error("Error updating document: ", error);
                    });
            },
             */
            loadLandesVerband(){
                this.verein = null;
                this.currentVerein = null;
                if ( this.user.permissions['lv' + this.id] || this.user.permissions.pass ) {
                    this.$store.dispatch('bindRealtimeDocument', {
                        collection: 'landesverbaende',
                        docId: this.id,
                        storeField: 'landesverbaende.' + this.id,
                        //emptyObject: new Landesverband()
                    });
                }
                this.landesverband = new Landesverband();
            },
            setLandesverband(){
                this.landesverband.setFromDataObject(this.landesverbandRaw);
                this.landesverband.id = this.landesverbandRaw.id;
            },
            reselectVerein(inactive){
                this.selectVerein(this.verein, inactive)
            },
            selectVerein(item, inactive){
                this.verein = item;
                const queryField = inactive ?
                    'search.inaktiv.' + this.landesverband.id + this.verein.id :
                    'search.membershipYears.' + this.landesverband.id + this.verein.id + "_" + this.sportJahr;
                this.$store.dispatch('unbindRealtimeList', 'vereinsspieler');
                this.$store.dispatch('bindRealtimeList', {
                    collection: 'spieler',
                    queryField: queryField,
                    queryOperator: '==',
                    queryValue: true,
                    //docId: this.id,
                    storeField: 'vereinsspieler',
                });
                this.$store.dispatch('unbindRealtimeList', 'vereinsspielerExpired');
                if ( !inactive ) {
                    const today = TimeStamp.getTodayString();
                    this.$store.dispatch('bindRealtimeList', {
                        collection: 'spieler',
                        queryField: 'search.lastAktiv.' + this.landesverband.id + this.verein.id,
                        queryOperator: '<',
                        queryValue: today,
                        //docId: this.id,
                        storeField: 'vereinsspielerExpired',
                    });
                }
                this.$store.dispatch('unbindRealtimeList', 'pendingActions');
                this.$store.dispatch('bindRealtimeList', {
                    collection: 'spieler_actions',
                    queryField: 'status_lvVerein_pending',
                    queryOperator: 'array-contains',
                    queryValue: this.landesverband.id + '' + this.verein.id,
                    storeField: 'pendingActions',
                });
            },
            openVereinNew(){
                this.currentVerein = null;
                this.openVereinEdit();
            },
            openVereinEdit(){
                let p = JSON.parse(JSON.stringify(this.$route.path));
                let q = JSON.parse(JSON.stringify(this.$route.query));
                q.action = 'editVerein';
                this.$router.push({path: p, query: q});
            },
            vereinsAction(action){
                if ( action === 'edit' ) {
                    this.currentVerein = JSON.parse(JSON.stringify(this.verein));
                    this.openVereinEdit();
                } else if ( action === 'datenblatt' ) {
                    this.currentVerein = JSON.parse(JSON.stringify( this.landesverbandRaw.id + this.verein.id));
                } else {
                    this.deleteVerein();
                }
            },
            changeVerein(verein){
                this.verein = verein;
            },
            async deleteVerein(){
            // check aktive
                const pActive = FirebaseRead.readDocList('spieler', {
                    field: 'search.membershipYears.' + this.landesverband.id + this.verein.id + "_" + this.sportJahr,
                    operator: '==', value: true
                })
            // check inaktive
                const pInactive = FirebaseRead.readDocList('spieler', {
                    field: 'search.inaktiv.' + this.landesverband.id + this.verein.id,
                    operator: '==', value: true
                })
            // check expired
                const today = TimeStamp.getTodayString();
                const pExpired = FirebaseRead.readDocList('spieler', {
                    field: 'search.lastAktiv.' + this.landesverband.id + this.verein.id,
                    operator: '<', value: today
                })
            // load and sum up vereinspieler
                const vereinsspielerLists = await Promise.all([pActive, pInactive, pExpired])
                let noOfVereinsspieler = 0
                vereinsspielerLists.forEach( (list) => { noOfVereinsspieler += list.length});
                if ( noOfVereinsspieler > 0 ) {
                    this.deleteSnack.text = 'Dieser Verein kann nicht gelöscht werden ' +
                                            'weil er aktive oder inaktive Spieler hat!';
                    this.deleteSnack.color = 'error';
                    this.deleteSnack.show = true;
                    return;
                }
                this.requestDeleteConfirm();
            },
                requestDeleteConfirm(){
                    this.confirmDelete.header = 'Verein löschen';
                    this.confirmDelete.question = "Möchtest du den Verein '" + this.verein.name +
                                                  "' wirklich endgültig löschen?";
                    this.confirmDelete.open = true;
                },
                processConfirm(reply) {
                    if ( reply ) {
                        this.processDeletion();
                    }
                    this.confirmDelete.open = false;
                },
                async processDeletion(){
                    this.landesverband.local.documentUpdates = {
                        ['vereine.' + this.verein.id]: firestore.FieldValue.delete()
                    };
                    let reply = await this.landesverband.saveEdited();
                    if ( reply.successful ) {
                        this.verein = null;
                        this.deleteSnack.text = 'Der Verein wurde erfolgreich gelöscht!',
                        this.deleteSnack.color = 'success';
                        this.deleteSnack.show = true;
                    }
                }
        },
        watch: {
            landesverbandRaw(){
                if ( this.landesverbandRaw ) { this.setLandesverband(); }
            },
            sportJahr(){
                if ( this.landesverband && this.landesverband.id && this.verein ) {
                    this.selectVerein(this.verein);
                }
            },
            id(){
                this.loadLandesVerband();
            }
        }
    }
</script>

<style scoped>
    .navDrawer { position: fixed; bottom: 0; border-right: solid 1px lightgrey;
        top: 48px; left: 0; width: 200px; overflow-y: auto;}
    .navDrawerMob { position: fixed; bottom: 0; border-right: solid 1px lightgrey;
                    top: 48px; left: 0; right: 0; background-color: white; z-index: 1; overflow-y: auto}
    .content { position: fixed; bottom: 0; top: 48px; right: 0;
                left: 200px; overflow-y: auto; background-color: #f2f2f2}
    .logo {     position: absolute;   -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
        filter: grayscale(100%); opacity: 0.3;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);}
</style>